import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

import getTBWStore from "../../../stores/developer-store/tbw-store";
import { TCorePage, TTBWExtraData } from "../../../Types";
import Et3Button from "../../et3-button";

const InvestigateButton = withLiteObserverAndTheme<{
  extraData: TTBWExtraData;
  fromPage: TCorePage;

  style: {};
  disabled: boolean;
}>((props) => {
  const {
    extraData,
    fromPage,

    disabled
  } = props;
  return (
    <Et3Button
      isEnabled={!disabled}
      onClick={async () => {
        await getTBWStore().showActionTBWPopUp({
          type: "ACTION_TBW",
          headerMessage: i18n.getWithExtraData(
            "SELECT_REASONS_OF_ACTION",
            "investigate"
          ),
          actionName: "investigate",
          fromPage,
          extraData,
          issueAudit: "",
          eventId: -1
        });
      }}
      size="MEDIUM"
      text="INVESTIGATE"
      type="WARN"
    />
  );
});
export default InvestigateButton;
